import _, { isNull } from 'lodash';

export const validateRepeated =
  (targetFormKey, requiredMessage, repeatedMessage) =>
  (wrapperNamePath = '') =>
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || (!value.trim() && requiredMessage)) {
        return requiredMessage
          ? Promise.reject(`${requiredMessage} `)
          : Promise.resolve();
      }
      if (!value && value !== 0 && !requiredMessage) {
        return Promise.resolve();
      }

      const sameOrder = getFieldValue(wrapperNamePath)
        .map((data) => data[targetFormKey])
        .filter((order) => order === value);

      if (sameOrder.length > 1) {
        return Promise.reject(repeatedMessage || 'repeated order');
      }

      return Promise.resolve();
    },
  });

export const validateSpaceAndEnter = (label) => () => ({
  validator(_, value) {
    if (!value || !value.trim()) {
      return Promise.reject(`${label} is required`);
    }

    return Promise.resolve();
  },
});

export const validateTrigger = (
  changedValue,
  allFields,
  { getFieldValue, validateFields },
  targetKey,
  wrapperKey,
) => {
  const value = _.compact(changedValue[wrapperKey])[0];
  if (value && (value[targetKey] || isNull(value[targetKey]))) {
    const modules = getFieldValue(wrapperKey),
      VALIDATE_KEYS = modules.map((_, index) => [wrapperKey, index, targetKey]);
    validateFields(VALIDATE_KEYS);
  }
};
